// Utility function for creating page URLs
export function createPageUrl(pageName) {
  const routes = {
    'Home': '/',
    'Projects': '/projects',
    'ProjectEditor': '/project',
    'Schedule': '/schedule',
  };
  return routes[pageName] || '/';
}

// Generate unique ID
export function generateId() {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}
